export default "__VITE_ASSET__DfX11Sy$__"